module.exports = __webpack_public_path__ + "img/7126ec4.svg";